// Module
var code = "<div class=\"contact-card-popover-container\" v-if=\"contact != null\" role=\"dialog\"> <contact-card :contact=\"contact\" :remove=\"remove\"></contact-card> </div> ";
// Exports
export default code;